export default "__VITE_ASSET__b5z23XSe__"